<template>
    <v-container>
       
        <v-layout row>
            <v-flex xs12>
                <v-layout row>
                    <v-flex xs12 sm6 pr-3 pt-5 style="font-size: 16px;line-height: 28px;">
                        <h2 class="headline mb-4">Your profile settings, {{ user.username }}</h2>
                        <h3 class="subheading">Upload your avatar here</h3>
                        <v-layout row>
                            
                            <v-flex xs12>
                                <input 
                                v-if="!uploading"
                                style="display:none;" 
                                type="file" 
                                @change="onFileSelected" 
                                ref="fileInput">
                                <v-btn @click="$refs.fileInput.click()">Upload File</v-btn>
                                
                            <v-img max-height="240" max-width="240" :src="avatarUrl">
                                <v-layout
                                        slot="placeholder"
                                        fill-height
                                        align-center
                                        justify-center
                                        ma-0
                                    >
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-layout>
                            </v-img>
                            <v-layout
                                    v-if="uploading"
                                    slot="placeholder"
                                    ma-0
                                >
                                    <v-progress-circular 
                                    color="blue"
                                    :rotate="-90"
                                    :size="100"
                                    :width="15"
                                    :value="uploadProgress"
                                    >{{ uploadProgress }}%</v-progress-circular>
                                </v-layout>


                            </v-flex>
                        </v-layout>

                    </v-flex>
                    
                </v-layout>
            </v-flex>
        </v-layout>
       
    </v-container>
</template>

<script>
import * as firebase from 'firebase';

export default {
    data() {
        return {
            selectedFile: null,
            //uploadImgSrc: '',
            //uploading: false,
            //uploadProgress: 0
        }
    },
    computed: {
        user() {
            return this.$store.getters.user
        },
        uploading() {
            return this.$store.getters.uploading
        },
        uploadProgress() {
            return this.$store.getters.uploadProgress
        },
        avatarUrl() {
            return this.$store.getters.user.picUrl
        }
    },
    methods: {
        
        onFileSelected(event) {
            this.selectedFile = event.target.files[0]
            this.$store.dispatch('uploadUserPic', this.selectedFile)
        },
        onUpload(){
            this.uploading = true
            const fd = this.selectedFile
            // maybe store selected file's name - this.selectedFile.name
            //eg. this.$store.dispatch('setLeadUpload', this.selectedFile.name)
            let storage = firebase.storage();
            let storageRef = storage.ref();
            let uploadTask = storageRef.child('images/' + this.selectedFile.name).put(fd);

            let that = this;
            // Register three observers:
            // 1. 'state_changed' observer, called any time the state changes
            // 2. Error observer, called on failure
            // 3. Completion observer, called on successful completion
            uploadTask.on('state_changed', function(snapshot){

            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            that.uploadProgress = Math.round(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log('Upload is ' + that.uploadProgress + '% done');
            switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log('Upload is paused');
                break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log('Upload is running');
                break;
            }
            }, function(error) {
                // Handle unsuccessful uploads
            }, function() {
                that.uploading = false;
                // Handle successful uploads on complete
                // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    console.log('File available at', downloadURL)
                    that.uploadImgSrc = downloadURL
                    var user = that.getters('getUser')
                    user.picUrl = that.uploadImgSrc
                    that.$store.dispatch('updateUser', user)
                });
            });
            /*
            axios.post(
                'https://', fd, { 
                    onUploadProgress: uploadEvent => {
                        console.log('Progress: ' + Math.round(uploadEvent.loaded / uploadEvent.total * 100) + '%')
                    } //firebase cloud function endpoint
            })
            .then(res => {
                console.log(res)
            })*/
        }
    }
}
</script>

<style>

input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
</style>
